import React from 'react';
import { useActiveWeb3React } from '../../../../hooks';
import { useGetYetiswapMarketCommissionRateNonYTS, useGetYetiswapMarketCommissionRateYTS } from '../../../../hooks/useNFTMarketPlace';
import { getTokenPrice } from '../../../../services/NFTMarketPlace/ApiCall';
import { getCollectionWithOnSale } from '../../../../services/NFTMarketPlace/Graphquery';
import { COLLECTION } from '../../data/NFTMarketPerPages';
import useGetNFTCollection from '../../data/useGetNFTCollection';
import { INFTCollectionItems } from '../../models/INFTCollectionItems';
import IPriceInfo from '../../models/IPriceInfo';
import NFTCollectionCard from '../Collection/NFTCollectionCard';
import CollectionPageHeader from './CollectionPageHeader';
import { CollectionContent, CollectionPageWrapper } from './styled';
import Helmet from 'react-helmet';
import Scrollbar from '../../components/Scrollbar';
import debounce from 'lodash/debounce';
import { ListFooter, ListItemsContainer } from '../../newComponents/NFTList/styled';
import Loader from '../../../../components/Loader';
import NFTButton from '../../newComponents/NFTButton';
import { loadNFTLikeCounts } from '../../data/useNFTLikeCount';


const CollectionPage = (props: any) => {
    const { match } = props
    const { tokenContract } = match.params
    const [skipItems, setSkipItems] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [hasMore, setHasMore] = React.useState<boolean>(true);
    const [collectionData, setCollectionData] = React.useState<INFTCollectionItems[]>([])
    const { account } = useActiveWeb3React()
    const [priceInfo, setPriceInfo] = React.useState<IPriceInfo | null>(null)
    const yetiswapMarketCommissionRateYTS = useGetYetiswapMarketCommissionRateYTS()
    const yetiswapMarketCommissionRateNonYTS = useGetYetiswapMarketCommissionRateNonYTS()
    const collection = useGetNFTCollection(tokenContract.toLowerCase());
    const [showOnSales, setShowOnSales] = React.useState<boolean>(false);

    const showOnSaleChange = React.useCallback((checked) => {
        setSkipItems(0);
        setHasMore(true);
        setCollectionData([]);
        setShowOnSales(checked)
    }, [setShowOnSales, setSkipItems]);

    React.useEffect(() => {
        getTokenPrice().then((res: any) => setPriceInfo(res))
    }, [])

    const getCollectionItems = React.useCallback(() => {
        if (collection) {
            setIsLoading(true);
            getCollectionWithOnSale(collection.tokenAddress, skipItems, showOnSales).then((response: INFTCollectionItems[] | null) => {
                setIsLoading(false);
                if (response) {
                    loadNFTLikeCounts(response.map((r: INFTCollectionItems) => ({ collectionAddress: r.contract.id, tokenID: +r.tokenID })));
                    if (response.length < COLLECTION.LIST) {
                        setHasMore(false);
                    }

                    if (skipItems === 0) {
                        setCollectionData(response)
                    } else {
                        setCollectionData([...collectionData, ...response])
                    }
                }
            })
        }
    }, [skipItems, collection, showOnSales]);

    const onLoadMore = React.useCallback(() => {
        setSkipItems(skipItems + COLLECTION.LIST);
    }, [skipItems]);

    React.useEffect(() => {
        setCollectionData([])
        setSkipItems(0)
    }, [tokenContract])

    React.useEffect(() => {
        getCollectionItems()
    }, [skipItems, collection, showOnSales])

    const onScroll = debounce((position: any) => {
        const isBottom = position && (position.clientHeight + position.scrollTop >= position.scrollHeight - 400);
        if (isBottom && onLoadMore && skipItems != 0 && hasMore && !isLoading) {
            onLoadMore()
        }
    }, 200);

    return (
        <Scrollbar onUpdate={onScroll}>
            <CollectionPageWrapper>
                <Helmet>
                    <title>{collection?.name + " Collection on YetiSwap NFT Marketplace"}</title>
                </Helmet>
                <CollectionPageHeader
                    collection={collection}
                    onShowOnSaleChange={showOnSaleChange}
                    showOnSale={showOnSales}
                />
                <CollectionContent>
                    <ListItemsContainer>
                        {collectionData.map((data: INFTCollectionItems, index) => (
                            <NFTCollectionCard
                                key={`${index}_WALLET_CARD_${data.tokenID}`}
                                contractAddress={data.contract.id}
                                yetiswapMarketCommissionRateYTS={yetiswapMarketCommissionRateYTS}
                                yetiswapMarketCommissionRateNonYTS={yetiswapMarketCommissionRateNonYTS}
                                account={account ? account : ''}
                                tokenId={+data.tokenID}
                                owner={data.owner.id}
                                priceInfo={priceInfo}
                                noButtons={false}
                            />
                        ))}
                    </ListItemsContainer>
                    <ListFooter>
                        {collectionData.length > 0 && skipItems == 0 && hasMore && !isLoading &&
                            <NFTButton style={{ flex: 'unset', width: 200 }} onClick={onLoadMore}>Load More</NFTButton>
                        }
                        {isLoading && <Loader size='50px' />}
                    </ListFooter>
                </CollectionContent>
            </CollectionPageWrapper>
        </Scrollbar>
    )
}

export default CollectionPage;